import React from 'react';

function Quality() {
  return (
    <div>
      <h2>Quality</h2>
      <p>This is the Quality page. Content coming soon!</p>
    </div>
  );
}

export default Quality;
